<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Vehicle Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">Vehicle Identification Number</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{VC_IDTFY_NUMS}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">Vehicle Number</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{VC_NUMS}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">VCU ID</th>
                               <td class="text-left pl-5 tableLinerB">{{VCU_ID}}</td>
                               <th class="listHeader tableLinerB" >MCU_ID</th>
                               <td class="text-left pl-5 tableLinerB">{{MCU_ID}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>
  
                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>User Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                               <th class="listHeader tableLinerT" style="width:20%">Company</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{USR_COMPNAY_NAME}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%"> - </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Member ID</th>
                               <td class="text-left pl-5">{{USR_ID}}</td>
                               <th class="listHeader" >Name</th>
                               <td class="text-left pl-5">{{USR_NM}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Phone</th>
                               <td class="text-left pl-5 tableLinerB">{{HP}}</td>
                               <th class="listHeader tableLinerB" >Email</th>
                               <td class="text-left pl-5 tableLinerB">{{EMAIL}}</td>
                           </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <h3>Reserve Info</h3>
                        <v-simple-table>
                            <tbody>
                                <tr>
                               <th class="listHeader tableLinerT" style="width:20%">Charger Station</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{BSS_NM}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">Charger ID</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">{{CHG_BSS_CHGR_ID}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Battery ID 1</th>
                               <td class="text-left pl-5">{{CHG_BSS_CELL_ID1}}</td>
                               <th class="listHeader" >Battery ID 2</th>
                               <td class="text-left pl-5">{{CHG_BSS_CELL_ID2}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Status</th>
                               <td class="text-left pl-5 tableLinerB">{{RSV_INFO}}</td>
                               <th class="listHeader tableLinerB" >Date</th>
                               <td class="text-left pl-5 tableLinerB">
                                   <div v-for="(item) in RSV_LOG" :key="item.RSV_LOG_SEQ">
                                        <div>
                                           <span>{{item.RSV_STEP}} Date : </span>
                                           <span>{{item.INS_DTM}}</span>
                                        </div>
                                    </div>
                                </td>
                           </tr>
                            </tbody>
                        </v-simple-table>

                        <div class="mt-10">
                        <div class="d-flex justify-space-between dense pa-0 ">
                            <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <!--
                                <v-btn color="red lighten-2" small dark class="ml-2 px-5">Delete</v-btn>
                                <v-btn color="primary" small dark class="ml-2 px-6" @click="editInfo()">Edit</v-btn>
                                -->
                            </div>
                        </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'ReserveDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
            // login Info
            gnbCode:"4", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "예약 상세",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: '충전예약관리', disabled: true,}, { text: '예약현황', disabled: true,}, { text: '예약 상세', disabled: false,}],
            NavList: [ 
                        { action: 'mdi-car-turbocharger', active: true, title: '충전예약현황', nums: '1',
                            items: [ { title: '예약 리스트', nums:11, href:'/Reserve', icons:'mdi-format-list-bulleted' }],
                        },
                    ],     

            schRsvSeq:'',      

            RSV_SEQ:"",  USR_ID:"", CHG_BSS_SEQ:"", CHG_BSS_CHGR_ID:"", CHG_BSS_CELL_ID1:"", CHG_BSS_CELL_ID2:"",  
            RSV_INFO:"", RSV_STATUS:"", EXP_DTM:"", INS_DTM:"", USR_NM:"",  VC_IDTFY_NUMS :"", VC_NUMS :"",  BSS_NM:"", COUNTRY_CODE:"", NAT_NAME_KR:"", USR_COMPNAY_NAME:"", USR_COMPNAY_NUM:"",
            VCU_ID:"", MCU_ID:"", RSV_LOG:[],
            
            HP:"", EMAIL:"",
            emptyFlag: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.Seq);
        this.schRsvSeq = this.$route.params.Seq;
        if(this.schRsvSeq == '' || this.schRsvSeq == undefined) {
            this.schRsvSeq = localStorage.getItem("schRsvSeq");
        }
        if(this.schRsvSeq != '') {
            this.getInfo();
            //this.getHistory();
        } else {
            alert("Not Data");
            this.$router.replace('Reserve');
        }
        window.scrollTo(0, 0);
    },

    methods : {
        
        // API Async 
        getInfo() {
            //console.log("this.schRsvSeq= "+ this.schRsvSeq);
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "rsvSeq": this.schRsvSeq
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/reserveInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.RSV_SEQ = json.RSV_SEQ; this.USR_ID = json.USR_ID; this.CHG_BSS_SEQ = json.CHG_BSS_SEQ; 
                    this.CHG_BSS_CHGR_ID = json.CHG_BSS_CHGR_ID; this.CHG_BSS_CELL_ID1 = json.CHG_BSS_CELL_ID1;
                    this.CHG_BSS_CELL_ID2 = json.CHG_BSS_CELL_ID2; this.RSV_STATUS = json.RSV_STATUS; 
                    this.EXP_DTM = json.EXP_DTM; this.INS_DTM = json.INS_DTM; 
                    this.USR_NM = json.USR_NM;
                    this.VC_IDTFY_NUMS = json.VC_IDTFY_NUMS; this.BSS_NM = json.BSS_NM; this.COUNTRY_CODE = json.COUNTRY_CODE;
                    this.NAT_NAME_KR = json.NAT_NAME_KR; this.VC_NUMS = json.VC_NUMS;
                    this.HP = json.HP; this.EMAIL=json.EMAIL;
                    this.USR_COMPNAY_NAME = json.USR_COMPNAY_NAME;
                    this.USR_COMPNAY_NUM = json.USR_COMPNAY_NUM;
                    this.RSV_INFO = json.RSV_INFO;
                    this.VCU_ID = json.VCU_ID; this.MCU_ID = json.MCU_ID;
                    if(json.value != undefined && json.value.list != undefined) {
                        this.RSV_LOG = json.value.list;
                    }
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Reserve'});
        }

    }

}
</script>
